/**
 * llm-json — 把 LLM 回覆「盡力」解析成單一 JSON 物件。
 *
 * 實測 bridge(claude -p)回覆形狀不穩定(2026-06-11):
 *   - 乾淨單一物件 {"prompt":...}
 *   - ```json 圍欄包物件
 *   - 物件外包一層陣列 [{...}](尤其平行壓力下)
 *   - 物件前後夾雜說明文字
 * 原本嚴格 JSON.parse 把後三種全當失敗 → 「生不出變形題」。本模組統一容錯。
 */

/** 盡力從 LLM 文字撈出 JSON 陣列(容忍圍欄/單物件/夾雜文字);撈不到回 null。 */
export function coerceJsonArray(text: string): unknown[] | null {
  const cleaned = String(text).replace(/^```(?:json)?\s*|\s*```$/g, '').trim();
  try {
    const p = JSON.parse(cleaned);
    if (Array.isArray(p)) return p;
    if (p && typeof p === 'object') return [p];
  } catch {
    /* fallthrough */
  }
  const m = cleaned.match(/\[[\s\S]*\]/);
  if (m) {
    try {
      const p = JSON.parse(m[0]);
      if (Array.isArray(p)) return p;
    } catch {
      /* noop */
    }
  }
  return null;
}

/** 盡力從 LLM 文字撈出單一 JSON 物件;撈不到回 null,永不 throw。 */
export function coerceJsonObject(text: string): Record<string, unknown> | null {
  const cleaned = text.replace(/^```(?:json)?\s*|\s*```$/g, '').trim();
  let parsed: unknown;
  try {
    parsed = JSON.parse(cleaned);
  } catch {
    // 夾雜文字 → 抓第一個 {...} 區塊再試一次。
    const m = cleaned.match(/\{[\s\S]*\}/);
    if (!m) return null;
    try {
      parsed = JSON.parse(m[0]);
    } catch {
      return null;
    }
  }
  if (Array.isArray(parsed)) parsed = parsed[0]; // [{...}] → 取第一筆
  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return null;
  return parsed as Record<string, unknown>;
}
